import React, { PropsWithChildren } from 'react'
import styles from './Main.module.scss'

export interface Props {}

const Main = ({ children }: PropsWithChildren<Props>) => (
  <div className={styles.Main} data-testid="Main" role="main">
    <div className={styles.Main__content}>{children}</div>
  </div>
)

export default Main
